//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const heart = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 5, 3, 3, 5, 5, 3, 3, 5, 0, 0, 
    0, 5, 3, 4, 4, 3, 3, 4, 4, 3, 5, 0, 
    5, 3, 4, 2, 2, 4, 4, 2, 2, 4, 3, 5, 
    3, 4, 2, 2, 2, 2, 2, 2, 2, 2, 4, 3, 
    3, 4, 2, 2, 2, 1, 1, 2, 2, 2, 4, 3, 
    0, 3, 4, 2, 2, 1, 1, 2, 2, 4, 3, 0, 
    0, 0, 3, 4, 2, 2, 2, 2, 4, 3, 0, 0, 
    0, 0, 5, 3, 4, 2, 2, 4, 3, 5, 0, 0, 
    0, 0, 0, 5, 3, 4, 4, 3, 5, 0, 0, 0, 
    0, 0, 0, 0, 5, 3, 3, 5, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 5, 5, 0, 0, 0, 0, 0,
]